import "./AuskunftBoKat.css";
import {Button} from "@radix-ui/themes/dist/esm";

function AuskunftBoKat() {

    return (
        <div className="auskunft-container">

            <Button
                id="btn-auskunft"
                className="auskunft-btn"
                type="button"
                text="Auskunft aus dem Bodenschutzkataster"
                variant="solid"
                aria-label="Auskunft aus dem Bodenschutzkataster. Öffnet in einem neuen Fenster."
                onClick={() => window.open(
                    'https://antrag.service.rlp.de/civ.public/start.html?oe=00.00.1401.OZG.ALTL&mode=cc&cc_key=100AnFiAuskunftBodenschutzkataster',
                    '_blank',
                    'noopener,noreferrer'
                )}
            >
                Auskunft aus dem Bodenschutzkataster
            </Button>
            <span className="auskunft-erlaeuterung">
                Sie möchten wissen, ob auf einem Grundstück ein Verdacht auf Altlasten oder schädliche
                Bodenveränderungen besteht? Dann können Sie eine Auskunft aus dem Altlastenkataster bei der
                dafür zuständigen Behörde beantragen.
            </span>

        </div>
    );
}


export default AuskunftBoKat;
